@if (config) {
  <div class="drawer">
    @for (sectionId of ['header', 'body', 'footer']; track sectionId) {
      <div class="drawer__section" [attr.data-section]="sectionId">
        @for (widget of config.sections[sectionId]; track widget.id) {
          @if (widget.enabled && !isHiddenOnEmpty(widget.type)) {
            @switch (widget.type) {
              @case (SmartCartBlockType.TOP_BAR) {
                <top-bar-preview [settings]="topBarSettings(widget.settings)" [itemCount]="3"></top-bar-preview>
              }
              @case (SmartCartBlockType.CART_ITEMS) {
                <cart-items-preview
                  [settings]="cartItemsSettings(widget.settings)"
                  [globalButtonDesign]="globalButtonDesign()"></cart-items-preview>
              }
              @case (SmartCartBlockType.CART_SUBTOTAL) {
                <cart-subtotal-preview [settings]="cartSubtotalSettings(widget.settings)"></cart-subtotal-preview>
              }
              @case (SmartCartBlockType.CHECKOUT_AREA) {
                <checkout-area-preview
                  [settings]="checkoutAreaSettings(widget.settings)"
                  [globalButtonDesign]="globalButtonDesign()"></checkout-area-preview>
              }
              @case (SmartCartBlockType.DISCOUNT_CODES) {
                <discount-codes-preview
                  [settings]="discountCodesSettings(widget.settings)"
                  [globalButtonDesign]="globalButtonDesign()"></discount-codes-preview>
              }
              @case (SmartCartBlockType.ANNOUNCEMENT_BAR) {
                <announcement-bar-preview
                  [settings]="announcementBarSettings(widget.settings)"></announcement-bar-preview>
              }
              @case (SmartCartBlockType.GOALS_PROGRESS_BAR) {
                <goals-progress-bar-preview
                  [settings]="goalsSettings(widget.settings)"
                  [globalButtonDesign]="globalButtonDesign()"></goals-progress-bar-preview>
              }
              @case (SmartCartBlockType.UPSELL_ITEMS) {
                <upsell-items-preview
                  [settings]="upsellSettings(widget.settings)"
                  [globalButtonDesign]="globalButtonDesign()"></upsell-items-preview>
              }
              @case (SmartCartBlockType.DIGITAL_UPSELL) {
                <digital-upsell-preview [settings]="digitalUpsellSettings(widget.settings)"></digital-upsell-preview>
              }
              @default {}
            }
          }
        }
      </div>
    }
  </div>
}
